import { create } from "zustand";

type DayStatus = "OPEN" | "CLOSED" | "UNKNOWN";

interface DayState {
  currentDate: string | null; // ISO date string e.g. '2026-03-13'
  dayStatus: DayStatus;
  dayRecordId: string | null;

  // Actions
  setDay: (date: string, status: DayStatus, dayRecordId?: string) => void;
  setDayStatus: (status: DayStatus) => void;
  resetDay: () => void;
}

export const useDayStore = create<DayState>()((set) => ({
  currentDate: null,
  dayStatus: "UNKNOWN",
  dayRecordId: null,

  setDay: (date, status, dayRecordId) =>
    set({
      currentDate: date,
      dayStatus: status,
      dayRecordId: dayRecordId ?? null,
    }),

  setDayStatus: (dayStatus) => set({ dayStatus }),

  resetDay: () =>
    set({ currentDate: null, dayStatus: "UNKNOWN", dayRecordId: null }),
}));
